<template>
  <div class="card" v-show="isSection('favorites')">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>自分の好きなもの</h2>
      </div>
      <div class="card-content-list myprofile-favorites-grid">
        <div
          class="myprofile-form-group"
          v-for="(fav, idx) in favoritesConfig"
          :key="'fav-' + fav.id"
        >
          <label class="myprofile-label"
            ><span class="myprofile-fav-icon">{{ fav.icon }}</span
            >{{ fav.label }}</label
          >
          <el-input
            :value="favoriteItem(idx)"
            :placeholder="fav.label"
            @input="(val) => setFavorite(idx, val)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { isCardSectionActive } from '@/utils/format-edit/cardSections'
import favoritesConfig from '@/utils/format-edit/myprofileFavoritesConfig.json'
import {
  setStringListItem,
  stringListItem
} from '@/utils/format-edit/myprofileFields'

const props = defineProps<{
  currentCardId?: string
  formatId?: string
}>()

const formatData = useRirekishoFormatData()

const isSection = (section: string) =>
  isCardSectionActive(props.formatId, props.currentCardId, section)

function favoriteItem(idx: number) {
  return stringListItem(formatData.favorites, idx)
}

function setFavorite(idx: number, val: string) {
  setStringListItem(formatData, 'favorites', idx, val, 6)
}
</script>

<style lang="scss" scoped>
.myprofile-form-group {
  margin-bottom: 16px;

  .myprofile-label {
    display: block;
    font-size: 13px;
    color: #555;
    margin-bottom: 4px;
    font-weight: bold;

    .myprofile-fav-icon {
      margin-right: 4px;
    }
  }
}

.myprofile-favorites-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 16px;
}

@media (width <= 768px) {
  .myprofile-favorites-grid {
    grid-template-columns: 1fr;
  }
}
</style>
